import { IUser } from "@rentiohq/shared-frontend/dist/types/auth.types";
import {
  IFormikValues,
  IFormStep,
} from "@rentiohq/web-shared-next/dist/utils/types/form";
import { uiSchema } from "./schema.profileExtra";
import { getInitialValues } from "./schema.profileExtra.utils";

export const profileExtraSchema =
  (extraData: IUser) =>
  (): { formStepsSchema: IFormStep[]; initialValues: IFormikValues } => {
    const initialValues = getInitialValues(extraData);
    const formStepsSchema = [
      {
        uiSchema: uiSchema(),
      },
    ];

    // @ts-ignore
    return { formStepsSchema, initialValues };
  };
